import React, { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import PsContext from "../../context";
import { MOB_ICONS, momentDate, MuiConfirmWindow } from "../../utils";
import axios from "axios";
import { ServiceUrl } from "../../utils/serviceUrl";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Modal } from "antd-mobile";
import { useNavigate } from "react-router-dom";

const FeeLink = (props) => {
  const context = useContext(PsContext);
  const [totalBalance, setTotalBalance] = useState(0);
  const [feeData, setFeeData] = useState([]);
  const [showReminder, setShowReminder] = useState(false);
  const [reminderText, setReminderText] = useState([]);
  const [notificationCount, setNotificationCount] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    setTotalBalance(context.getStorage("stu_my_fee_balance"));
    loadMyFees();
    loadDataNotification();
  }, []);

  const loadMyFees = () => {
    const form = new FormData();
    form.append("balance_only", "1");
    axios.post(ServiceUrl.STUDENTS.MY_FEES, form).then((res) => {
      if (res["data"].status == "1") {
        context.setStorage("stu_my_fee_balance", res["data"].balance);
        setTotalBalance(res["data"].balance);
        if (res.data.data) {
          setFeeData(res.data.data);
          context.setStorage("stu_my_fee_data", JSON.stringify(res.data.data));
        }
      }
    });
  };

  const loadDataNotification = () => {
    const form = new FormData();
    form.append("type", "student");
    form.append("uuid", context.user.uuid);
    form.append("course", context.user.course);
    axios.post(ServiceUrl.STUDENTS.MY_NOTIFICATION_COUNT, form).then((res) => {
      if (res["data"].status == "1") {
        if (parseInt(res["data"].data.history_count) > 0) {
          setNotificationCount(
            parseInt(res["data"].data.count) -
              parseInt(res["data"].data.history_count)
          );
        } else {
          setNotificationCount(parseInt(res["data"].data.count));
        }
      } else {
      }
      //  setLoader(false);
    });
  };

  // useEffect(() => {
  //   let showAlert = sessionStorage.getItem("mob_stu_fee_pop_pending") || "0";
  //   if (showAlert == "0") {
  //     if (
  //       feeData &&
  //       feeData.length > 0 &&
  //       totalBalance &&
  //       parseFloat(totalBalance) > 0
  //     ) {
  //       let rv = [];
  //       feeData.map((item, i) => {
  //         rv.push(
  //           <div className="border-bottom pb-2">
  //             This is a reminder that your {item.cashbook_name} of Rs.
  //             <b>{item.total}</b> are due now.
  //             {item.fee_due_date && (
  //               <span>
  //                 Please make sure to pay by the deadline of{" "}
  //                 {momentDate(item.fee_due_date, "DD/MMM/YYYY")} to avoid any
  //                 late fees.
  //               </span>
  //             )}
  //           </div>
  //         );
  //       });

  //       setReminderText(rv);
  //       setShowReminder(true);
  //     }
  //   }
  // }, [feeData]);

  useEffect(() => {
    let showAlert = sessionStorage.getItem("mob_stu_fee_pop_pending") || "0";

    if (showAlert == "0") {
      let rv = [];
      if (
        feeData &&
        feeData.length > 0 &&
        totalBalance &&
        parseFloat(totalBalance) > 0
      ) {
        feeData.map((item, i) => {
          rv.push(
            <div className="border-bottom pb-2">
              This is a reminder that your {item.cashbook_name} of Rs.
              <b>{item.total}</b> are due now.
              {item.fee_due_date && (
                <span>
                  Please make sure to pay by the deadline of{" "}
                  {momentDate(item.fee_due_date, "DD/MMM/YYYY")} to avoid any
                  late fees.
                </span>
              )}
            </div>
          );
        });
      }
      if (notificationCount > 0) {
        rv.push(
          <div
            className="border-bottom pb-2"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/stu/app/notification")}
          >
            You have <b>{notificationCount}</b> unread notification(s).
            <span style={{ color: "#A2C8E8" }}> Click here to view.</span>
          </div>
        );
      }

      if (rv.length > 0) {
        setReminderText(rv);
        setShowReminder(true);
      }
    }
  }, [feeData, notificationCount]);

  return (
    <>
      <Col md={3} xs={4} sm={4}>
        <Link to="/stu/app/my-fees">
          <Card className="shadow-none menu-card">
            <CardContent className="p-0 rounded h-100">
              <Typography
                sx={{
                  color: "text.secondary",
                  fontSize: 14,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={MOB_ICONS.FEES_IMG}
                  className="mt-2"
                  style={{ width: "47px" }}
                />
              </Typography>
              <div
                className="text-center text-black mt-1"
                style={{
                  overflowY: "hidden",
                  fontSize: "13px",
                }}
              >
                {props.title}
                {totalBalance && parseFloat(totalBalance) > 0 ? (
                  <span className="text-danger fw-bolder">
                    &nbsp; {totalBalance}
                  </span>
                ) : (
                  "My Fees"
                )}
              </div>
            </CardContent>
          </Card>
        </Link>
      </Col>

      <MuiConfirmWindow
        title="Reminder"
        open={showReminder}
        onClose={(e) => {
          setShowReminder(false);
          setReminderText([]);
          sessionStorage.setItem("mob_stu_fee_pop_pending", "1");
        }}
      >
        {reminderText}
      </MuiConfirmWindow>
    </>
  );
};
export default FeeLink;
